<div class="flex-auto gt-xs:pr-3 w-full mb-2">
  <ts-chip-autocomplete
    mode="combined"
    placeholder="New tag..."
    hint="Press Enter or comma to add a tag"
    [label]="fieldDef.label"
    [testId]="'form-field-' + fieldDef.name"
    [formControl]="control"
    [items]="foundTags"
    [remoteSearch]="true"
    (search)="onSearch($event)"
  />
</div>
